import AdminLogsModule from '@/modules/admin-logs';
import { createFileRoute } from '@tanstack/react-router';
import { AccessDenied } from '../../../components/ui/access-denied';
import { useAccessControl } from '../../../hooks/useAccessControl';

export const Route = createFileRoute('/dashboard/admin-logs/')({
  component: AdminLogsPage,
});

function AdminLogsPage() {
  const { canAccessHorizonTemplateRequests } = useAccessControl();
  if (!canAccessHorizonTemplateRequests) {
    return <AccessDenied />;
  }
  return <AdminLogsModule />;
}
